import React from 'react';
import { Folder, File, ChevronRight, ChevronDown } from 'lucide-react';
import { FileItem } from '../types/space';
interface FileTreeProps {
  files: FileItem[];
  level?: number;
}
export function FileTree({
  files,
  level = 0
}: FileTreeProps) {
  return <div className="w-full select-none" data-id="element-69">
      {files.map(file => <div key={file.id} data-id="element-70">
          <div className={`
              flex items-center py-1.5 px-2 hover:bg-gray-50 cursor-pointer text-sm
              ${file.name === 'index.html' ? 'bg-blue-50 text-blue-700' : 'text-gray-600'}
            `} style={{
        paddingLeft: `${level * 16 + 12}px`
      }} data-id="element-71">
            {file.type === 'folder' ? <>
                {file.isOpen ? <ChevronDown className="h-3.5 w-3.5 text-gray-400 mr-1.5" data-id="element-72" /> : <ChevronRight className="h-3.5 w-3.5 text-gray-400 mr-1.5" data-id="element-73" />}
                <Folder className="h-4 w-4 text-blue-300 mr-2" data-id="element-74" />
              </> : <File className="h-4 w-4 text-gray-400 mr-2 ml-5" data-id="element-75" />}
            <span className="truncate" data-id="element-76">{file.name}</span>
          </div>
          {file.type === 'folder' && file.children && file.isOpen && <FileTree files={file.children} level={level + 1} data-id="element-77" />}
        </div>)}
    </div>;
}